import { render, staticRenderFns } from "./prestockLists.vue?vue&type=template&id=579345b6&scoped=true&"
import script from "./prestockLists.vue?vue&type=script&lang=js&"
export * from "./prestockLists.vue?vue&type=script&lang=js&"
import style0 from "./prestockLists.vue?vue&type=style&index=0&id=579345b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579345b6",
  null
  
)

export default component.exports